import React from 'react'

const PorteaServices = () => (
  <div className="box is-radiusless is-shadowless services-panel">
    <div className="header">Portea Services</div>
    <div className="service-item">
      <i className="icn-service doctor" />
      <p>Doctor Consultation</p>
    </div>
    <div className="service-item">
      <i className="icn-service nursing" />
      <p>Nursing</p>
    </div>
    <div className="service-item">
      <i className="icn-service physio" />
      <p>Physiotherapy</p>
    </div>
    <div className="service-item">
      <i className="icn-service attendant" />
      <p>Trained Attendant</p>
    </div>
    <div className="service-item">
      <i className="icn-service elder" />
      <p>Elder Care</p>
    </div>
    <div className="service-item">
      <i className="icn-service mother" />
      <p>Mother & Baby Care</p>
    </div>
    <div className="service-item">
      <i className="icn-service lab" />
      <p>Lab Tests</p>
    </div>
    <div className="service-item">
      <i className="icn-service equipment" />
      <p>Medical Equipment</p>
    </div>
    <div className="service-item">
      <i className="icn-service pharma" />
      <p>Speciality Pharma</p>
    </div>
    <div className="service-item">
      <i className="icn-service critical" />
      <p>Critical Care</p>
    </div>
  </div>
)

export default PorteaServices;
